import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const { TextArea } = Input;

const propTypes = {
  rows: PropTypes.number,
};
const defaultProps = {
  rows: 4,
};

const renderField = ({ input, label, rows }) => (
  <Fragment>
    <label htmlFor={input.name}>{label}</label>
    <TextArea {...input} id={input.name} rows={rows} />
  </Fragment>
);

renderField.propTypes = propTypes;
renderField.defaultProps = defaultProps;

export default renderField;
